//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { PojoMap } from 'pojo-maps';

import { deserializeRightsPermissions } from '@apis/rights-management/rightsManagementApiUtils';
import Cuid from '@models/Cuid';
import { IMlsMediaItem } from '@models/IMlsMediaItem';
import { isDefined } from '@utils/filterPredicates';
import { Serialized } from '@utils/types/Serialized';

export const deserializeMediaItem = (
  item: Serialized<IMlsMediaItem>,
): IMlsMediaItem => ({
  ...item,
  adMetadata: item.adMetadata?.adCode
    ? {
        adCode: {
          ...item.adMetadata.adCode,
          createdAt: new Date(item.adMetadata.adCode.createdAt),
          expirationTime: parseOptionalDate(
            item.adMetadata.adCode.expirationTime,
          ),
        },
      }
    : undefined,
  libraryMetadata: item.libraryMetadata && {
    ...item.libraryMetadata,
    addedToLibraryTimestamp: parseOptionalDate(
      item.libraryMetadata.addedToLibraryTimestamp,
    ),
  },
  rightsPermissions: deserializeRightsPermissions(item.rightsPermissions),
  networkItem: item.networkItem && {
    ...item.networkItem,
    firstObservationTime: parseOptionalDate(
      item.networkItem.firstObservationTime,
    ),
    networkData: {
      ...item.networkItem.networkData,
      addedToCollectionTimestamp: parseOptionalDate(
        item.networkItem.networkData?.addedToCollectionTimestamp,
      ),
    },
    observationTime: new Date(item.networkItem.observationTime),
    postedTime: new Date(item.networkItem.postedTime),
  },
});

export const deserializeMediaItems = (
  mediaItems: Serialized<PojoMap<Cuid, IMlsMediaItem>>,
): PojoMap<Cuid, IMlsMediaItem> => {
  return PojoMap.map(mediaItems, (item) => deserializeMediaItem(item));
};

const parseOptionalDate = (date: string | number | Date | undefined) => {
  return isDefined(date) ? new Date(date) : undefined;
};
